import { Button, Result, Spin, Tag } from '@bfe/moly';
import { ImageWithDefault } from '@web3/components';
import qrCode from 'qrcode';
import { useEffect, useRef } from 'react';
import { useChainList } from '../../store/chainList';
import { useCopyToClipboard } from 'react-use';
import { useLocale } from '../../store/i18nMessage';
import { useToastFn } from '../../hooks';

export type DisplayTokenDepositProps = {
  // 接收的
  chainCode?: string;
  walletAddress?: string;
  // 地址类型
  addressType?: string;
  // 接受的token 名称
  token?: string;
  mneChain?: boolean;
};

export function DisplayTokenDeposit({ chainCode, walletAddress, addressType, mneChain = false }: DisplayTokenDepositProps) {
  const { getChain, chainList } = useChainList();
  const qrRef = useRef<HTMLCanvasElement>(null);

  const chain = getChain(chainCode, mneChain ? 'mnemonicChainList' : 'chainList');
  const toast = useToastFn();
  const [, copy] = useCopyToClipboard();
  const { t } = useLocale();

  useEffect(() => {
    if (!qrRef.current || !walletAddress) {
      return;
    }
    qrCode.toCanvas(qrRef.current, walletAddress, {
      width: 234,
      margin: 0,
    });
  }, [walletAddress]);

  if (!chainList.length) {
    return (
      <div className="flex justify-center">
        <Spin />
      </div>
    );
  }

  if (!chainCode || !walletAddress || !chain) {
    return <Result status="error" className="mt-10" style={{ minHeight: 380 }} title="no address or chain" />;
  }

  return (
    <div className="px-8">
      <div className="flex flex-col items-center gap-6">
        <div className="flex items-center gap-1">
          <ImageWithDefault src={chain?.iconDayUrl} size={24} className="rounded-full" />
          <span className="text-lg">{chain?.chainName}</span>
        </div>
        <div className=" border border-solid border-bds-gray-ele-border p-2">
          <canvas className="block" ref={qrRef}></canvas>
        </div>
        <div className="text-base font-bold break-all text-center text-bds-gray-t2">
          {addressType ? <Tag className="align-baseline ltr:mr-1 rtl:ml-1">{addressType}</Tag> : null}
          {walletAddress}
        </div>
        <div className="text-center text-bds-brand-700-normal text-sm">
          {chainCode === 'ZKV2'
            ? t('deposit_chain_tips', { chain1: `${chain?.chainName || ''}`, chain2: 'zkSync Lite' })
            : t('deposit_tips', { token: `${chain?.chainName || ''}` })}
        </div>
        <Button
          variant="primary"
          className="w-full mb-2"
          onClick={() => {
            if (walletAddress) {
              copy(walletAddress);
              toast.success(t('copied'));
            }
          }}
        >
          {t('copy_address')}
        </Button>
      </div>
    </div>
  );
}

export type DisplayToken = {
  chainCode?: string;
  walletAddress?: string;
  token?: string;
};
